import { useCallback, useEffect, useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import "./productmasterlisting.scss";
import threedotvertical from "../../../assets/images/three-dots-vertical.svg";
import editicon from "../../../assets/images/edit-icon.svg";
import viewicon from "../../../assets/images/view-icon.svg";
import duplicateicon from "../../../assets/images/duplicate-icon.svg";
import deleteicon from "../../../assets/images/delete-icon.svg";
import exporticon from "../../../assets/images/export-icon.svg";
import importicon from "../../../assets/images/import-icon.svg";
import CustomModal from "../../../components/customModal/CustomModal";
import uploadfileicon from "../../../assets/images/upload-file-icon.svg";
import { ReactSVG } from "react-svg";
import useProducts from "../../../Hooks/useProduct";
import Loading from "../../../components/LoadingPage/Loading";
import {
  Product,
  setSelectedProduct,
} from "../../../redux/product/productSlice";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCurrentUserId } from "../../../redux/auth/authSlice";
import { toggleClass } from "../../../utils/commonUtils";
import { DuplicateModel } from "./popup/duplicateModel";
import { DeleteConfModel } from "../../../components/DeleteConfModel/deleteConfModel";
import { toast } from "react-toastify";
import React from "react";
import moment from "moment";
import CommonPagination from "../../../global/Pagination/CommonPagination";
import { checkPermission, PermissionIdentifier, PermissionModule } from "../../../utils/permissionUtils";
const ProductMasterListing = () => {
  const [showImportFileModal, setShowImportFileModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const currentUserId = useAppSelector(selectCurrentUserId);
  const [sortColumn, setSortColumn] = useState("productCode");
  const [sortDirection, setSortDirection] = useState('asc');
  const defaultFilter = { searchText: "", sortColumn: "productCode", sortDirection: "asc" };
  const [searchFieldVal, setSearchFieldVal] = useState(defaultFilter);
  const {
    getProductAPI,
    deleteProductAPI,
    duplicateProductAPI,
    getProductLoading,
    deleteProductLoading,
    setProductStatusActiveLoading,
    setProductStatusDeActiveLoading,
    duplicateProductLoading,
    onExportProductMasterList,
    exportProductMasterLoading,
    onImportProductMasterFile,
    importProductMasterLoading,
  } = useProducts();
  const [showModal, setShowModal] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [importErrorDetails, setImportErrorDetails] = useState<any[]>([]);
  const [productList, setProductsList] = useState<Product[]>([]);
  const [totalProducts, setTotalProducts] = useState<number>(0);
  const [currentProduct, setCurrentProduct] = useState<Product>();
  const deleteProduct = async () => {
    await deleteProductAPI({
      id: currentProduct?.id,
      updatedBy: currentUserId ?? "",
    });
    toggleModal();
    getProducts();
  };
  const toggleModal = () => {
    toggleClass();
    setShowModal(!showModal);
  };
  const toggleDuplicateModal = () => {
    toggleClass();
    setShowDuplicateModal(!showDuplicateModal);
  };

  const getProducts = (currPage?: number, perPage?: number) => {
    getProductAPI({
      ...searchFieldVal,
      includeDeleted: false,
      pageNumber: currPage,
      pageSize: perPage,
    })
      .then((res: { result: Product[]; totalRecords: number }) => {
        setProductsList(res?.result);
        setTotalProducts(res?.totalRecords);
      })
      .catch();
  };
  const editProduct = (Product: Product) => {
    dispatch(setSelectedProduct(Product));
    navigate("/edit-product-master");
  };
  const navigateToView = (Product: Product) => {
    dispatch(setSelectedProduct(Product));
    navigate("/view-product-master");
  };
  const duplicateProduct = async (barcode: string) => {
    await duplicateProductAPI({
      barcode,
      id: currentProduct?.id,
      updatedBy: currentUserId ?? "",
    });
    toggleDuplicateModal();
    getProducts();
  };
  const handleSort = (columnName: string) => {
    if (sortColumn === columnName) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
      setSearchFieldVal({ ...searchFieldVal, sortColumn: columnName, sortDirection: sortDirection === 'asc' ? 'desc' : 'asc' });
    }
    else {
      setSortColumn(columnName);
      setSortDirection('asc');
      setSearchFieldVal({ ...searchFieldVal, sortColumn: columnName, sortDirection: 'asc' });
    }
  };

  useEffect(() => {
    getProducts();
  }, [searchFieldVal]);

  const toggleImportXlsxModal = () => {
    setSelectedFile(null);
    setImportErrorDetails([]);
    toggleClass();
    setShowImportFileModal(!showImportFileModal);
  };

  const onExportClick = async () => {
    const response = await onExportProductMasterList();
    const url = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${localStorage.getItem("profileClientId")?.toUpperCase() ?? ""}_Product_master_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  };

  const selectFile = (event: any) => {
    const file = event.target.files[0];

    // Check if file is selected
    if (!file) {
      toast.error("No file selected");
      return;
    }

    // Check file type (must be .xlsx)
    const fileType = file.type;
    if (
      fileType !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      toast.error("Please upload a valid .xlsx file");
      return;
    }

    // Check file size (must be <= 5MB)
    const fileSizeMB = file.size / (1024 * 1024); // convert to MB
    if (fileSizeMB > 5) {
      toast.error("File size must not exceed 5MB");
      return;
    }
    setSelectedFile(file);
  };

  const handleFileImport = async () => {
    const formData = new FormData();
    formData.append("file", selectedFile || "");
    const response = await onImportProductMasterFile(formData);
    if (
      response.error &&
      response.error.data?.status !== 200 &&
      response.error.data?.result?.isSuccess === false
    ) {
      if (response.error.data?.status === 400) {
        toast.error(response.error.data?.result?.errorMessage);
      }
      toast.error("Error!. File imported unsuccessfully");
      const errorData = response.error.data?.result?.data?.filter(
        (data: any) => data.isValid === false
      );
      setImportErrorDetails(errorData);
    } else {
      toggleImportXlsxModal();
      getProducts();
    }
  };

  const handlePaginationChange = useCallback(
    (page: number, perPage: number) => {
      getProducts(page, perPage);
    },
    []
  );

  return (
    <div className="product-master-listing-wrapper">
      {getProductLoading ||
        deleteProductLoading ||
        setProductStatusActiveLoading ||
        setProductStatusDeActiveLoading ||
        exportProductMasterLoading ||
        importProductMasterLoading ||
        duplicateProductLoading ? (
        <Loading />
      ) : null}
      <div className="listing-title-box">
        <div className="listing-title-info">
          <h2>Product Master</h2>
          <p>
            Displaying {productList.length} of {totalProducts} Results
          </p>
        </div>
        <div
          className="listing-searchbar-wrapper"
          style={{ justifyContent: "space-evenly" }}
        >
          <div
            className="listing-searchbar-item-wrapper"
            style={{ flex: "none", display: "contents" }}
          >
            <div className="listing-searchbar-item-box">
              <input
                type="text"
                min={0}
                className="form-control"
                placeholder="Search"
                onChange={(e: any) => {
                  setSearchFieldVal({
                    ...searchFieldVal,
                    searchText: e.target.value,
                  });
                }}
                value={searchFieldVal?.searchText ?? ""}
              />
            </div>
            <Button
              type="button"
              variant="outline-secondary"
              className="btn-search"
              onClick={() => {
                setSearchFieldVal({ ...defaultFilter });
              }}
            >
              Clear
            </Button>
          </div>
        </div>
        <div className="listing-action-box">
          <div className="import-export-box-wrapper">
            {checkPermission(PermissionModule.PRODUCT_MASTER, PermissionIdentifier.IMPORT_PRODUCT_MASTER) && (
              <span
                className="import-export-btn import-btn"
                onClick={toggleImportXlsxModal}
              >
                <ReactSVG className="svg-box" wrapper="span" src={importicon} />{" "}
                Import
              </span>
            )}
            {checkPermission(PermissionModule.PRODUCT_MASTER, PermissionIdentifier.EXPORT_PRODUCT_MASTER) && (
              <span
                className="import-export-btn export-btn"
                onClick={onExportClick}
              >
                <ReactSVG className="svg-box" wrapper="span" src={exporticon} />{" "}
                Export
              </span>
            )}
          </div>
          {checkPermission(PermissionModule.PRODUCT_MASTER, PermissionIdentifier.CREATE_PRODUCT_MASTER) && (
            <div className="action-box">
              <Button variant="primary" href="/add-product-master">
                <i className="bi bi-plus"></i>
                Add New
              </Button>
            </div>
          )}
        </div>
      </div>

      <div className="listing-table-wrapper">
        <Table responsive="md" hover={true}>
          <thead>
            <tr>
              <th onClick={() => handleSort('productCode')}>
                Product Code / NDC {sortColumn === 'productCode' && (sortDirection === 'asc' ? '↑' : '↓')}
              </th>
              {/* <th>Barcode</th> */}
              <th onClick={() => handleSort('productName')}>
                Product Name {sortColumn === 'productName' && (sortDirection === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('category')}>
                Category / RXGroup {sortColumn === 'category' && (sortDirection === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('manufacturer')}>
                Manufacturer {sortColumn === 'manufacturer' && (sortDirection === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('subCode')}>
                Sub Code {sortColumn === 'subCode' && (sortDirection === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('model')}>
                Model / CVX {sortColumn === 'model' && (sortDirection === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('mvxCode')}>
                MVX Code {sortColumn === 'mvxCode' && (sortDirection === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('mvxManufacturer')}>
                MVX Manufacturer {sortColumn === 'mvxManufacturer' && (sortDirection === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('mvxStatus')}>
                MVX Status {sortColumn === 'mvxStatus' && (sortDirection === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('isMedicine')}>
                IsMed {sortColumn === 'isMedicine' && (sortDirection === 'asc' ? '↑' : '↓')}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {productList?.map((product: Product) => (
              <tr
                key={product.id}
                onDoubleClick={() => {
                  navigateToView(product);
                }}
              >
                <td title={product.productCode}>{product.productCode}</td>
                {/* <td title={product.barcode}>{product.barcode}</td> */}
                <td title={product.productName}>{product.productName}</td>
                <td title={product.category}>{product.category}</td>
                <td title={product.manufacturer}>{product.manufacturer}</td>
                <td title={product.productCode.split("-").join("")}>
                  {product.productCode.split("-").join("")}
                </td>
                <td title={product.model}>{product.model ?? "-"}</td>
                <td title={product.mvxCode}>{product.mvxCode ?? "-"}</td>
                <td title={product.mvxManufacturer}>
                  {product.mvxManufacturer ?? "-"}
                </td>
                <td title={product.mvxStatus}>{product.mvxStatus ?? "-"}</td>
                <td>
                  <span
                    className={`status-circle ${product.isMedicine ? "active" : "inactive"}`}
                  >
                    {product.isMedicine ? "Yes" : "No"}
                  </span>
                </td>
                <td>
                  <Dropdown>
                    <Dropdown.Toggle variant="link">
                      <ReactSVG
                        className="svg-box"
                        wrapper="span"
                        src={threedotvertical}
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => navigateToView(product)}>
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={viewicon}
                        />
                        View
                      </Dropdown.Item>
                      {checkPermission(PermissionModule.PRODUCT_MASTER, PermissionIdentifier.EDIT_PRODUCT_MASTER) && (
                        <Dropdown.Item onClick={() => editProduct(product)}>
                          <ReactSVG
                            className="svg-box"
                            wrapper="span"
                            src={editicon}
                          />
                          Edit
                        </Dropdown.Item>
                      )}
                      {checkPermission(PermissionModule.PRODUCT_MASTER, PermissionIdentifier.DELETE_PRODUCT_MASTER) && (
                        <Dropdown.Item
                          onClick={() => {
                            setCurrentProduct(product);
                            toggleModal();
                          }}
                        >
                          <ReactSVG
                            className="svg-box"
                            wrapper="span"
                            src={deleteicon}
                          />
                          Delete
                        </Dropdown.Item>
                      )}
                      {checkPermission(PermissionModule.PRODUCT_MASTER, PermissionIdentifier.DUPLICATE_PRODUCT_MASTER) && (
                        <Dropdown.Item
                          onClick={() => {
                            setCurrentProduct(product);
                            toggleDuplicateModal();
                          }}
                        >
                          <ReactSVG
                            className="svg-box"
                            wrapper="span"
                            src={duplicateicon}
                          />
                          Duplicate
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <CommonPagination
        totalRecords={totalProducts}
        onChange={handlePaginationChange}
      />

      <DeleteConfModel
        showModal={showModal}
        toggleModal={toggleModal}
        deleteAction={deleteProduct}
        recordName={currentProduct?.productName || ""}
        modelName={`product`}
      />
      <DuplicateModel
        showModal={showDuplicateModal}
        toggleDuplicateModal={toggleDuplicateModal}
        duplicateProduct={duplicateProduct}
        currentProduct={currentProduct}
      />
      {showImportFileModal && (
        <CustomModal
          id="upload-avatar-modal"
          title="Import"
          content={
            <>
              <div className="modal--content--wrapper">
                <div className="img-upload-box">
                  <Form.Control
                    type="file"
                    id="avatar-upload-input"
                    accept=".xlsx"
                    onChange={selectFile}
                  />
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={uploadfileicon}
                  />
                  <p>Drag and Drop your file here or Click to Upload</p>
                </div>
                <div className="file-type-hint">
                  <span>File Type: .xlsx</span>
                  <span>Maximum Size: 5 MB</span>
                </div>
                {selectedFile?.name && (
                  <div className="file-type-hint">
                    <span>File Name: {selectedFile?.name}</span>
                  </div>
                )}
              </div>
              {importErrorDetails && importErrorDetails?.length > 0 && (
                <div className="import-error-section">
                  <h3>Error Details</h3>
                  <Table responsive="md" hover={true} className="error-tbl">
                    <thead>
                      <tr>
                        <th>Product Code / NDC</th>
                        <th>barcode</th>
                        <th>Error Message</th>
                      </tr>
                    </thead>
                    <tbody>
                      {importErrorDetails.map((item) => (
                        <tr key={item.barcode}>
                          <td>{item?.productCode}</td>
                          <td>{item?.barcode}</td>
                          <td className="error-info">{item?.errorMessage}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <p>Please correct this data in excel sheet & try again..!</p>
                </div>
              )}
              <div className="modal--action--btn--wrapper">
                <Button
                  type="button"
                  variant="outline-primary"
                  onClick={toggleImportXlsxModal}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  variant="primary"
                  onClick={handleFileImport}
                  disabled={!selectedFile}
                >
                  Import
                </Button>
              </div>
            </>
          }
          onClose={toggleImportXlsxModal}
        />
      )}
    </div>
  );
};

export default ProductMasterListing;
